'use strict'

function getErrorMessage(error) {
  if (error.status) {
    if (!error.data) {
      return 'An unexpected error occurred'
    } else {
      return error.data
    }
  } else {
    return error
  }
}

export { getErrorMessage }
